(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      // Close search flyover instead of modal
      const searchFlyover = document.getElementById('search-flyover');
      const searchInput = document.getElementById('Search-In-Header');
      if (searchFlyover) {
        searchFlyover.classList.remove('active');
      }
      if (searchInput) {
        searchInput.blur();
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Search Flyover Control
  (function() {
    const searchInput = document.getElementById('Search-In-Header');
    const searchFlyover = document.getElementById('search-flyover');
    const searchFlyoverCloseButton = searchFlyover ? searchFlyover.querySelector('.header__search-flyover-close') : null;
    const suggestionWindow = document.getElementById('suggestion-window');
    
    if (!searchInput || !searchFlyover) return;
    
    // Ensure presearch flyover is never visible on load (fix empty presearch tab on load)
    searchFlyover.classList.remove('active');

    // Function to update flyover position - panel below search bar with spacing
    function updateFlyoverPosition() {
      const inputWrapper = searchInput.closest('.header__search-input-wrapper');
      const searchSection = searchInput.closest('.header__search-section');
      const anchorEl = inputWrapper || searchSection;
      const anchorRect = anchorEl?.getBoundingClientRect();
      if (anchorRect) {
        searchFlyover.style.top = (anchorRect.bottom + 12) + 'px';
      }
    }

    // Show flyover on focus/click
    searchInput.addEventListener('focus', function() {
      updateFlyoverPosition();
      searchFlyover.style.opacity = '';
      searchFlyover.style.visibility = '';
      searchFlyover.style.pointerEvents = '';
      searchFlyover.classList.add('active');
    });

    // Clear button functionality
    const clearButton = document.querySelector('.header__clear-button');
    
    function toggleClearButton() {
      const hasValue = searchInput.value.trim().length > 0;
      if (clearButton) {
        clearButton.style.display = hasValue ? 'flex' : 'none';
      }
    }
    
    searchInput.addEventListener('input', function(e) {
      const hasValue = e.target.value.trim().length > 0;
      toggleClearButton();
      // Show suggestions when empty, predictive search will show when typing
      if (hasValue && suggestionWindow) {
        suggestionWindow.style.display = 'none';
      } else if (!hasValue && suggestionWindow) {
        suggestionWindow.style.display = 'block';
      }
    });
    
    // Clear button click handler
    if (clearButton) {
      clearButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        searchInput.value = '';
        searchInput.focus();
        toggleClearButton();
        
        // Close predictive search if open
        const predictiveSearch = document.querySelector('predictive-search');
        if (predictiveSearch && predictiveSearch.hasAttribute('open')) {
          predictiveSearch.close(true);
        }
        
        // Show suggestions window
        if (suggestionWindow) {
          suggestionWindow.style.display = 'block';
        }
        
        // Trigger input event to update UI
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }
    
    // Check on focus
    searchInput.addEventListener('focus', function() {
      toggleClearButton();
    });

    // Update position on scroll/resize
    window.addEventListener('scroll', updateFlyoverPosition, { passive: true });
    window.addEventListener('resize', updateFlyoverPosition, { passive: true });

    // Hide flyover when clicking outside
    document.addEventListener('click', function(e) {
      const searchWrapper = searchInput.closest('.header__search-wrapper');
      if (searchWrapper && !searchWrapper.contains(e.target)) {
        searchFlyover.classList.remove('active');
        searchFlyover.style.opacity = '0';
        searchFlyover.style.visibility = 'hidden';
        searchFlyover.style.pointerEvents = 'none';
      }
    });

    // Hide flyover on Escape key
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        searchFlyover.classList.remove('active');
        searchFlyover.style.opacity = '0';
        searchFlyover.style.visibility = 'hidden';
        searchFlyover.style.pointerEvents = 'none';
        searchInput.blur();
      }
    });

    // Close flyover from dedicated close button (scoped + one-time binding).
    if (searchFlyoverCloseButton && !searchFlyoverCloseButton.dataset.flyoverCloseBound) {
      const closeFlyoverFromButton = function(e) {
        e.preventDefault();
        e.stopPropagation();
        searchFlyover.classList.remove('active');
        searchFlyover.style.opacity = '0';
        searchFlyover.style.visibility = 'hidden';
        searchFlyover.style.pointerEvents = 'none';

        const predictiveSearchEl = document.querySelector('predictive-search');
        if (predictiveSearchEl && predictiveSearchEl.hasAttribute('open') && typeof predictiveSearchEl.close === 'function') {
          predictiveSearchEl.close();
        }

        searchInput.blur();
      };

      searchFlyoverCloseButton.addEventListener('click', closeFlyoverFromButton);
      searchFlyoverCloseButton.dataset.flyoverCloseBound = 'true';
    }

    // Listen for predictive search open/close
    const predictiveSearch = document.querySelector('predictive-search');
    if (predictiveSearch) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            const isOpen = predictiveSearch.hasAttribute('open');
            if (isOpen && suggestionWindow) {
              suggestionWindow.style.display = 'none';
            } else if (!isOpen && searchInput.value.trim().length === 0 && suggestionWindow) {
              suggestionWindow.style.display = 'block';
            }
          }
        });
      });
      observer.observe(predictiveSearch, { attributes: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
